module.exports = __webpack_public_path__ + "img/check-circle-fill.63bc8c90.svg";